<template>
  <b-modal :id="id" :title="title" :size="size">
    <slot />
    <template #modal-footer="{ }">
      <b-button v-if="TituloConfirmar" size="lg" :class="classHabilitarConfirmar" @click="() => funcaoConfirmar()">
        {{ TituloConfirmar }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "Modal",
  props: {
    title: {
      type: String,
      default: "",
    },
    TituloConfirmar: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    habilitarConfirmar: {
      type: Boolean,
    },
    size: {
      type: String,
      default: "lg",
    },
    funcaoConfirmar: {
      type: Function,
    },
  },
  computed: {
    classHabilitarConfirmar() {
      return !this.habilitarConfirmar ? "btn-operacoes orange btn-desativado" : "btn-operacoes orange";
    },
  },
};
</script>
